// Assistant settings surface incl. settings avatar
// (WEB-8005). Composed by praxisStyles.ts at the section's original
// position — source order is part of the cascade.
export const praxisSettings = `
/* Settings surface */
.pr-settings-wrap {
  flex: 1; min-width: 0;
  background: var(--pr-bg);
  overflow-y: auto;
  /* Reserve a constant gutter for the vertical scrollbar so switching tabs
     with different content heights doesn't shift the layout horizontally. */
  scrollbar-gutter: stable;
}
.pr-settings {
  max-width: 680px; margin: 0 auto;
  padding: 32px 28px 48px;
  display: flex; flex-direction: column; gap: 28px;
}
.pr-settings-card {
  background: var(--pr-surface);
  border: 1px solid var(--pr-hairline);
  border-radius: var(--pr-r-lg);
  overflow: hidden;
}
.pr-settings-nav {
  display: flex; gap: 4px;
  padding: 4px;
  background: var(--pr-surface-2);
  border-radius: var(--pr-r-md);
  border: 1px solid var(--pr-hairline);
  align-self: flex-start;
}
.pr-settings-nav button {
  padding: 7px 14px; border-radius: var(--pr-r-sm);
  background: transparent; border: none;
  font-size: 12.5px; font-weight: 500; color: var(--pr-ink-3);
  cursor: pointer;
  transition: all 120ms ease;
  font-family: inherit;
}
.pr-settings-nav button:hover { color: var(--pr-ink); }
.pr-settings-nav button.on {
  color: var(--pr-ink);
  background: var(--pr-surface);
  box-shadow: var(--pr-shadow-sm);
}
.pr-settings-section-head {
  display: flex; align-items: baseline; gap: 10px;
  margin-bottom: 12px;
  /* Match the 18px horizontal padding used by .pr-group-hdr so the section
     count lines up with the per-group counts inside the card. */
  padding: 0 18px;
}
.pr-icon-dot {
  width: 32px; height: 32px;
  border-radius: var(--pr-r-sm);
  background: var(--pr-accent-soft);
  color: var(--pr-accent);
  display: grid; place-items: center;
  flex-shrink: 0;
}
.pr-icon-dot svg { width: 18px; height: 18px; stroke-width: 1.7; }
.pr-settings-section-head .pr-icon-dot { align-self: center; }
.pr-settings-section-head h3 {
  margin: 0;
  font-family: var(--pr-font-serif);
  font-size: 20px; font-weight: 500; color: var(--pr-ink); letter-spacing: -0.015em;
}
.pr-settings-section-head .pr-count {
  margin-left: auto; font-size: 12px; color: var(--pr-ink-4);
  font-variant-numeric: tabular-nums;
}

.pr-avatar-card {
  display: flex; align-items: center; gap: 12px;
  padding: 8px 12px;
}
.pr-avatar-card .pr-settings-btn {
  padding: 4px 10px;
  font-size: 12px;
}
.pr-avatar-card .pr-settings-btn svg { width: 12px; height: 12px; }
/* Keep the settings avatar visually identical to the header brand-dot */
.pr-avatar-lg {
  position: relative;
  width: 34px; height: 34px;
  border-radius: var(--pr-r-md);
  background: var(--pr-ink);
  display: grid; place-items: center;
  overflow: hidden;
  color: var(--pr-surface);
  font-family: var(--pr-font-serif); font-style: italic;
  font-weight: 500; font-size: 17px;
  letter-spacing: -0.01em;
  flex-shrink: 0;
}
.pr-avatar-lg img { width: 100%; height: 100%; object-fit: cover; display: block; }
.pr-avatar-card .pr-meta { flex: 1; min-width: 0; }
.pr-avatar-card .pr-meta .pr-name {
  font-family: var(--pr-font-serif); font-weight: 500; font-size: 17px;
  color: var(--pr-ink); letter-spacing: -0.01em;
  line-height: 1.15;
}
.pr-avatar-card .pr-meta .pr-sub {
  font-size: 11.5px; color: var(--pr-ink-4);
  margin-top: 2px;
}

.pr-settings-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 12px; border-radius: var(--pr-r-sm);
  background: var(--pr-surface);
  border: 1px solid var(--pr-border);
  color: var(--pr-ink);
  cursor: pointer;
  font-size: 12.5px; font-weight: 500;
  transition: all 120ms ease;
  font-family: inherit;
}
.pr-settings-btn:hover { border-color: var(--pr-ink-4); background: var(--pr-surface-2); }
.pr-settings-btn.primary { background: var(--pr-ink); color: var(--pr-surface); border-color: var(--pr-ink); }
.pr-settings-btn.primary:hover { background: var(--pr-accent); border-color: var(--pr-accent); }
.pr-settings-btn.danger { background: oklch(0.56 0.18 25); color: var(--pr-surface); border-color: oklch(0.56 0.18 25); }
.pr-settings-btn.danger:hover { background: oklch(0.48 0.19 25); border-color: oklch(0.48 0.19 25); }

.pr-group-hdr {
  display: flex; align-items: center; gap: 10px;
  width: 100%;
  padding: 12px 18px;
  background: transparent; border: none;
  cursor: pointer;
  text-align: left;
  transition: background 120ms ease;
  font-family: inherit;
}
.pr-group-hdr:hover { background: var(--pr-surface-2); }
.pr-subtle-hr { height: 1px; background: var(--pr-hairline); margin: 0; }
.pr-group-chevron { color: var(--pr-ink-4); transition: transform 150ms ease; flex-shrink: 0; display: grid; place-items: center; }
.pr-group-chevron svg { width: 14px; height: 14px; }
.pr-group-chevron.open { transform: rotate(90deg); }
.pr-group-tag { font-size: 13px; font-weight: 600; color: var(--pr-ink-2); letter-spacing: 0; }
.pr-group-count { margin-left: auto; font-size: 13px; color: var(--pr-ink-4); font-variant-numeric: tabular-nums; }

.pr-mem-row {
  display: flex; gap: 12px; align-items: flex-start;
  padding: 10px 18px 10px 40px;
  border-top: 1px solid var(--pr-hairline);
}
.pr-mem-row .pr-mem-body { flex: 1; min-width: 0; }
.pr-mem-row .pr-mem-key {
  font-size: 11px; color: var(--pr-ink-4); margin-bottom: 3px;
  font-family: var(--pr-font-mono);
  font-weight: 500;
}
.pr-mem-row .pr-mem-val { font-size: 13.5px; color: var(--pr-ink); line-height: 1.55; white-space: pre-wrap; }
.pr-mem-row .pr-mem-tools { display: flex; gap: 2px; opacity: 0; transition: opacity 120ms ease; flex-shrink: 0; }
.pr-mem-row:hover .pr-mem-tools { opacity: 1; }
.pr-mem-row .pr-mem-tools .pr-iconbtn { width: 24px; height: 24px; }
.pr-conf {
  padding: 2px 7px; border-radius: 4px; font-size: 11px;
  font-variant-numeric: tabular-nums; font-weight: 500;
  flex-shrink: 0;
  font-family: var(--pr-font-mono);
}
.pr-conf.hi { color: var(--pr-success); background: var(--pr-success-soft); }
.pr-conf.mid { color: var(--pr-warn); background: var(--pr-warn-soft); }
.pr-conf.lo { color: var(--pr-ink-4); background: var(--pr-surface-2); }

.pr-dream-entry {
  padding: 14px 18px;
  border-bottom: 1px solid var(--pr-hairline);
}
.pr-dream-entry:last-child { border-bottom: none; }
.pr-dream-entry-head {
  display: flex; align-items: center; gap: 10px;
  margin-bottom: 6px;
}
.pr-dream-entry-date {
  font-family: var(--pr-font-mono);
  font-size: 11px;
  color: var(--pr-ink-4);
  font-variant-numeric: tabular-nums;
}
.pr-dream-entry-tag {
  font-size: 10.5px; font-weight: 500;
  color: var(--pr-accent-ink);
  background: var(--pr-accent-soft);
  border: 1px solid var(--pr-accent-soft-2);
  padding: 1px 7px;
  border-radius: 999px;
  letter-spacing: 0.02em;
}
.pr-dream-entry-body {
  font-family: var(--pr-font-serif);
  font-size: 14px;
  font-style: italic;
  line-height: 1.6;
  color: var(--pr-ink-2);
  white-space: pre-wrap;
}
`;
